import { verifyApiResponse } from "@utils/apiResponseHelper";
import apiService, { getWindowLoader, hasWindowLoader, redirectToLogin } from "@utils/apiService";
// // eslint-disable-next-line import/no-unresolved
import { updateStateSubject } from "@gartner/genie-messenger-util";
import { Constants } from "@constants/Constants";

export function login() {
  if (hasWindowLoader("UCI_AUTH")) {
    return getWindowLoader("UCI_AUTH").then(data => {
      if (data?.systemMessage?.success) {
        let ifDataExists = Object.keys(data?.data);
        if (ifDataExists?.length) {
          updateStateSubject("login", data?.data);
        }
        else {
          redirectToLogin(data?.data?.host);
        }
      } else {
        redirectToLogin(data?.data?.host);
      }
    }).catch(() =>  {
      redirectToLogin()
    })
  }
  apiService
    .get(Constants.API.LOGIN)
    .then((response) => {
      const data = verifyApiResponse(response);
      if (data?.systemMessage?.success) {
        let ifDataExists = Object.keys(data?.data);
        if (ifDataExists?.length) {
          updateStateSubject("login", data?.data);
        }
      } else {
        updateStateSubject("login", {});
      }
    })
    .catch(() => updateStateSubject("login", null));
}
